import React from "react";
import PropTypes from "prop-types";

import { PdpAccordion } from "arv-extends";

function FeaturesComponent(props) {
  const {
    PdpData: {
      mainStyle: {
        finerDetails: { notes },
      },
    },
    className,
  } = props;
  return (
    <section
      className={`nw-pdp-desktopaccordionstory ${className} wc-pdp-accordion`}
    >
      {notes.list.map(item => (
        <p
          className={`nw-pdp-desktopaccordionstorydata ${className} wc-pdp-accordiondata`}
        >
          {item}
        </p>
      ))}
    </section>
  );
}

function CareUsageComponent(props) {
  const {
    PdpData: {
      mainStyle: {
        finerDetails: { compositionAndCare },
      },
    },
    className,
  } = props;
  return (
    <section
      className={`nw-pdp-desktopaccordionstory ${className} wc-pdp-accordion`}
    >
      {compositionAndCare.list.map(item => (
        <p
          className={`nw-pdp-desktopaccordionstorydata ${className} wc-pdp-accordiondata`}
        >
          {item}
        </p>
      ))}
    </section>
  );
}

function SpecificationComponent(props) {
  const {
    PdpData: {
      mainStyle: {
        finerDetails: { specs },
      },
    },
    className,
  } = props;
  return (
    <section
      className={`nw-pdp-desktopaccordionstory ${className} wc-pdp-accordion`}
    >
      {specs.list.map(item => (
        <p
          className={`nw-pdp-desktopaccordionstorydata ${className} wc-pdp-accordiondata`}
        >
          {item}
        </p>
      ))}
    </section>
  );
}

function DetailsComponent(props) {
  const {
    PdpData: {
      mainStyle: { story },
    },
    className,
  } = props;
  return (
    <section
      className={`nw-pdp-desktopaccordionstory ${className} wc-pdp-accordion`}
    >
      <p
        className={`nw-pdp-desktopaccordionstorydata ${className} wc-pdp-accordiondata`}
      >
        {story}
      </p>
    </section>
  );
}

function WarrantyComponent(props) {
  const {
    PdpData: {
      mainStyle: { warranty },
    },
    className,
  } = props;
  return (
    <section
      className={`nw-pdp-desktopaccordionstory ${className}  wc-pdp-accordion`}
    >
      <p
        className={`nw-pdp-desktopaccordionstorydata ${className}  wc-pdp-accordiondata`}
      >
        {warranty}
      </p>
    </section>
  );
}

const Details = {
  component: DetailsComponent,
};

const Specification = {
  component: SpecificationComponent,
};

const CareUsage = {
  component: CareUsageComponent,
};

const Features = {
  component: FeaturesComponent,
};

const Warranty = {
  component: WarrantyComponent,
};

DetailsComponent.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      story: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

WarrantyComponent.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      story: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

FeaturesComponent.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      finerDetails: PropTypes.shape({
        notes: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

SpecificationComponent.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      finerDetails: PropTypes.shape({
        specs: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

CareUsageComponent.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      finerDetails: PropTypes.shape({
        compositionAndCare: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

PdpAccordion.AccordionContents.Details = Details;
PdpAccordion.AccordionContents.CareUsage = CareUsage;
PdpAccordion.AccordionContents.Features = Features;
PdpAccordion.AccordionContents.Specification = Specification;
PdpAccordion.AccordionContents.Warranty = Warranty;
